import { useEffect, useState } from "react";

export const useDebounce = (value, delay, callback) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  useEffect(() => {
    if (debouncedValue && callback) {
      callback(debouncedValue);
    }
  }, [debouncedValue]);

  return debouncedValue;
};
